import { render, staticRenderFns } from "./Informacoes.vue?vue&type=template&id=52ddff04"
import script from "./Informacoes.vue?vue&type=script&lang=js"
export * from "./Informacoes.vue?vue&type=script&lang=js"
import style0 from "./Informacoes.vue?vue&type=style&index=0&id=52ddff04&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports